import {useLocation, useNavigate} from 'react-router-dom';

export const useOpenSupportTicket = () => {
  const location = useLocation();
  const navigate = useNavigate();
  return id =>
    navigate(`/dashboard/ai-helpdesk/ticket/${id}`, {
      state: {ticketReturnTo: location.pathname + location.search},
    });
};
